
<template>
<div class="form-container">
  <div class="form-region">
	   <com-page-title></com-page-title>
 <el-form :class="$store.state.operate=='详情'?'form-disabled':''" :disabled="$store.state.operate=='详情'"  ref="form" :model="form" label-width="160px">

		 <el-form-item  required label='标题'>
		<el-input placeholder='请填写' v-model='form.title' maxlength='100' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item required v-if="form.status==40"  label='副标题'>
		<el-input placeholder='请填写' v-model='form.subTitle' maxlength='100' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item v-if="form.status==20" required  label='一级分类'>
		 <el-radio-group v-model="form.parentId">
		 	<el-radio v-for="(item,index) in classifyList" :label="item.id">{{item.title}}</el-radio>
		 </el-radio-group>
		  </el-form-item>
		 <el-form-item label='排序'>
		<el-input type='number' placeholder='请填写' v-model='form.orders'  clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='是否上架'>
		 <el-switch v-model='form.isShow'></el-switch>
		  </el-form-item>
		  <el-form-item required v-if="form.status==20||form.status==30" label='图片'>
		  <com-form-uploaders  :limit='1' v-model='form.imgurl'></com-form-uploaders>
		   </el-form-item> 
		  
		
		<!-- <el-form-item   label='链接'>
		<el-input placeholder='请填写' v-model='form.urls' maxlength='200' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='分组ID'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.statusGroup' clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='类型ID'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.statusType' clearable></el-input>
		 </el-form-item>
		 <el-form-item   label='父级名称'>
		<el-input placeholder='请填写' v-model='form.parentName' maxlength='50' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='是否上级'>
		<el-switch v-model='form.isShow'></el-switch>
		 </el-form-item>
		 <el-form-item  label='状态'>
		<el-input placeholder='请填写' v-int  type='number' v-model='form.status' clearable></el-input>
		 </el-form-item>
		 <el-form-item   label='标签'>
		<el-input placeholder='请填写' v-model='form.tag' maxlength='100' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='摘要'>
		<el-input  type='textarea' v-model='form.brief' maxlength='2000' show-word-limit clearable></el-input>
		 </el-form-item>
		 <el-form-item  label='图片'>
		<com-form-uploaders  :limit='1' v-model='form.imgurl'></com-form-uploaders>
		 </el-form-item> -->
   <el-form-item>
     <el-button type="primary" @click="onSubmit">立即提交</el-button>
   </el-form-item>
 </el-form>
 </div>
</div>
</template>
<script>
  export default {
	  props: {
	  	id: {//主键id
	  		type: String,
	  		default: ''
	  	}
	  },
  data() {
  return {
    dateRange:[],//表单限制日期
  form: {
	id:'',//ID
	title:'',//标题
	subTitle:'',//副标题
	orders:'',//排序
	urls:'',//链接
	statusGroup:'',//分组ID
	statusType:'',//类型ID
	parentId:'',//父级ID
	parentName:'',//父级名称
	parentIds:'',//父级IDS
	isShow:true,//是否上级
	status:'',//状态
	tag:'',//标签
	brief:'',//摘要
	imgurl:'',//图片
	createId:'',//创建ID
	createTime:'',//创建时间
	extFlag:'',//扩展
	extMore:'',//扩展
	ext:'',//扩展字段
  },
  classifyList:[]
  }
  },
  methods: {
 onSubmit() {//表单提交
	 this.form.id=this.$store.state.operate=='复制'?'':this.id;
	if(!this.form.title){
		 this.$message.error('请填写标题');return;
	}

if(this.form.status==20){
	if(!this.form.parentId){this.$message.error('请选择一级分类');return;}
	this.form.parentName=(this.classifyList.find(item=>item.classifyId==this.form.parentId)||{}).title
}
if((this.form.status==20||this.form.status==30)&&!this.form.imgurl){
		 this.$message.error('请选择图片');return;
	}
	if(this.form.status==40&&!this.form.subTitle){
			 this.$message.error('请填写副标题');return;
		}
	 let url=this.form.id?`/api/Classify/PostClassifyUpdate`:`/api/Classify/PostClassifyAppend`;
	 let data=this.form;
 this.$axios.post(url,data).then(e => {
   this.$emit("callbackPage",{statusText:this.form.id?'编辑':'添加'}); 
  });
 }
  },mounted() {//根据id获取表单数据
   this.form.status=this.$route.query.status||'';
	  if(this.id){
		  this.$axios.get(`/api/Classify/GetClassify?id=${this.id}`).then(e => {
		   this.form=e;
		      if(this.$store.state.operate=='复制'){
			    this.$message.success('内容已经复制到表单');
		   }
		  });
	  }
	  if(this.form.status==20){
	  	this.$axios.get(`/api/Classify/GetClassifyQuery?status=10`).then(e => {
	  				this.classifyList=e;
	  	  });
	  }
      }
  }
</script>
